var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2079,
    zoomAndPan: "magnify",
    viewBox: "0 0 1559.25 1559.249931",
    height: 2079,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "b73740971b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "576ed07f0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 1558.5 0 L 1558.5 1558.5 L 0 1558.5 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f116c123b4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b73740971b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -155.925,
    width: 1871.1,
    fill: "#000000",
    y: -155.924993,
    height: 1871.099917,
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "3cb20923c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 1558.304688 0 L 1558.304688 1558.304688 L 0 1558.304688 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb128c7246"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 779.152344 0 C 348.839844 0 0 348.839844 0 779.152344 C 0 1209.46875 348.839844 1558.304688 779.152344 1558.304688 C 1209.46875 1558.304688 1558.304688 1209.46875 1558.304688 779.152344 C 1558.304688 348.839844 1209.46875 0 779.152344 0 Z M 779.152344 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a5b7bbc73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 1559,
    y: 0,
    height: 1559
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#576ed07f0a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#f116c123b4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0.000000000000078219)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a5b7bbc73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3cb20923c7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb128c7246)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f9cbb",
    d: "M 0 0 L 1558.304688 0 L 1558.304688 1558.304688 L 0 1558.304688 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDot);
export default __webpack_public_path__ + "static/media/BlueDot.e48b260e3c9fcd9d2c3a1817f421fc05.svg";
export { ForwardRef as ReactComponent };